export const HOTEL_ID = 'HOTEL';
export const HOTEL_LISTING_PAGE_ID = 'HOTEL Search Result';

// The GTM tracking events have different format so we need to define new constants.
// TODO: Redefine the event format so we can use the same constants.
export const LOB_HOTEL = 'Hotel';
export const HOTEL_LISTING_PAGE = 'hotel listing';
export const HOTEL_DETAIL_PAGE = 'hotel detail';
export const GUEST_DETAIL_PAGE = 'guest detail';
export const BOOKING_CONFIRMATION_PAGE = 'confirmation';
